<template>
  <div>
    <Loading :show="loading" />
    <router-view @reload="fetch(true)"></router-view>

    <div v-if="!activeOrders.length && !upcomingOrders.length && !loading" class="no-orders">
      <p>Hittade inga planerade resor.</p>
    </div>

    <div v-if="activeOrders.length" class="booking-group">
      <PrettyOrder v-for="order in activeOrders" :key="'a' + order.resvid" :order="order" :bookMoreCallback="bookMore" />
    </div>

    <div v-if="upcomingOrders.length" class="booking-group">
      <PrettyOrder v-for="order in upcomingOrders" :key="'u' + order.resvid" :order="order" :bookMoreCallback="bookMore" />
    </div>
  </div>
</template>

<script>
import API from '@/classes/API';
import Loading from '@/components/components/Loading';
import PrettyOrder from '@/components/components/PrettyOrder';

export default {
  data() {
    return {
      orders: {
        active: [],
        upcoming: [],
        archived: [],
      },
      categories: {},
      user: {},
      loading: false,
    };
  },
  components: {
    Loading,
    PrettyOrder,
  },
  computed: {
    activeOrders() {
      return this.orders.active;
    },
    upcomingOrders() {
      return this.orders.upcoming;
    },
    archivedOrders() {
      return this.orders.archived;
    },
  },
  methods: {
    async fetch(hideLoading) {
      if (!hideLoading) {
        this.loading = true;
      }
      const { user } = await API.get('/account/user');
      if (user) {
        this.user = user;
        const { data } = await API.get('/orders/upcoming-and-active');
        this.orders = data;
      }
      if (!hideLoading) {
        this.loading = false;
      }
    },
    goToBooking(no) {
      this.$router.push({ name: 'my booking', params: { bookingNumber: no } });
    },
    bookMoreWithLink(link, localOrder) {
      const lines = [];
      if (localOrder.details && localOrder.details.rows) {
        Object.values(localOrder.details.rows).forEach((rowGroup) => {
          rowGroup.forEach((row) => {
            lines.push({
              poolId: row.pool,
              status: row.cancelled ? 'C' : 'B',
            });
          });
        });
      }

      const orderData = {
        number: localOrder.resvid,
        numeric: localOrder.headlid,
        dateStart: localOrder.details.dateStart,
        dateEnd: localOrder.details.dateEnd,
        hasAccommodation: false,
        lines,
      };

      const parentAccommodation = localOrder.details.rows
        && localOrder.details.rows.accomodation
        && localOrder.details.rows.accomodation[0];
      if (parentAccommodation) {
        orderData.hasAccommodation = true;
        orderData.accomodationRow = parentAccommodation.row;
        orderData.accomodationName = parentAccommodation.name;
        orderData.accomodationDateArrival = parentAccommodation.arrival;
        orderData.accomodationDateDeparture = parentAccommodation.departure;
        orderData.accomodationGroup = parentAccommodation.group;
        orderData.helperPool = parentAccommodation.pool;
        orderData.helperUnit = parentAccommodation.unit;
      }

      this.$store.state.cart.addToOrder = orderData;

      this.$router.push(link);
    },
    bookMore(bookingType, localOrder) {
      const category = this.categories.find(cat => cat.slug === bookingType);

      this.bookMoreWithLink(category.link, localOrder);
    },
  },
  mounted() {
    this.fetch();

    const categories = {
      skipass: {
        title: 'Liftkort',
        has: false,
        slug: 'skipass',
        product_slug: '',
        link: '/liftkort?quick=1',
      },
      skischool: {
        title: 'Skidskola',
        has: false,
        slug: 'skischool',
        product_slug: '',
        link: '/skidskola/oversikt',
      },
      rental: {
        title: 'Utrustning',
        has: false,
        slug: 'rental',
        product_slug: '',
        link: '/skidhyra',
      },
      accomodation: {
        title: 'Boende',
        has: false,
        slug: 'accomodation',
        product_slug: '',
        link: '/boenden',
      },
    };

    this.categories = Object.values(categories);
  },
};
</script>

<style scoped lang="stylus">
@import '~@/global.styl'

.right
  float none

table
  width 100%
  thead
    th
      background-color: var(--booking-color-primary);
      color white
      padding 10px
      font-size: 15px;
  tr
    &:nth-child(odd)
      background-color: #f9f9f9;
  td
    padding-top 10px
    padding-bottom 10px
    padding-right 10px
    padding-left 10px
    font-size: 14px;
    font-weight: 300;
  .right
    text-align right
  .center
    text-align center

.disabled
  disabled-grey()

.mobile-title
  display none
+max-mobile()
  .mobile-title
    display block
    font-weight: 700
  thead
    display none
  tbody
    display block
    .table-row
      display: flex
      flex-wrap: wrap
      width 100%
      td
        display inline-block
        width 33%
        &.wide
          width 100%
          button
            width 100%
            max-width 300px

+max-screen(400px)
  tbody
    .table-row
      td
        width 50%
        text-align: left !important

.booking-group
  padding-bottom: 40px
  padding-top: 40px
  & > h2
    margin-bottom: 16px

.no-orders
  margin 3rem auto
  text-align: center
</style>



// WEBPACK FOOTER //
// MyPageJourney.vue?30025e72